<script setup>
import AdminCalendar from '@/components/Calendar/admin/AdminCalendar.vue';
export default {
    components: { AdminCalendar },
};
</script>

<template>
    <div>
        <AdminCalendar ref="calendar" />
    </div>
</template>

<style scoped lang="scss"></style>
